import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import type { MappableLedgerAccount } from '../xeroLedgerAccountMappings.types'

type CreateMappingParams = {
  mappableLedgerAccount: MappableLedgerAccount
  xeroLedgerAccountCode: string
  xeroLedgerAccountName: string
  isDefault: boolean
}

export const useCreateXeroLedgerAccountMapping = () => {
  const { displayNotification } = useNotifications()

  const createMappingMutator = useMutation(
    dashboardv99990101Client.postXeroLedgerAccountMapping
  )

  return async (params: CreateMappingParams) => {
    await createMappingMutator.mutateAsync(
      {
        body: params
      },
      {
        onSuccess: () => {
          displayNotification('Xero ledger account mapping created', {
            type: 'success'
          })
        },
        onError: () => {
          displayNotification('Failed to create Xero ledger account mapping', {
            type: 'error'
          })
        }
      }
    )
  }
}
